import { isNonEmptyArray, isNumber } from '@/utils/checks'
import {
  MINIMUM_INSURANCE_CARD_THRESHOLD,
  MAXIMUM_INSURANCE_CARDS_TO_DISPLAY
} from './constants'
import transformTextToSlug from '@/utils/transformTextToSlug'
type InsuranceCard = {
  img: string
  title: string
  count: number | string
  subtitle: string
  slug: string
  location: string
  anchorTitle: string
  forceAnchorTag?: boolean
}

const MINIMUM_DISPLAY_THRESHOLD = 20

export const applyMinInsuranceThreshold = (
  insuranceCards: InsuranceCard[]
): InsuranceCard[] | [] => {
  if (!isNonEmptyArray(insuranceCards)) {
    return insuranceCards
  }

  return insuranceCards
    .map((insuranceCard) => ({
      ...insuranceCard,
      insuranceSlug: transformTextToSlug(insuranceCard.title.toLowerCase())
    }))
    .reduce((acc, insuranceCard) => {
      if (
        isNumber(insuranceCard.count) &&
        insuranceCard.count >= MINIMUM_DISPLAY_THRESHOLD
      ) {
        return [
          ...acc,
          {
            ...insuranceCard
          }
        ]
      }

      return [...acc, { ...insuranceCard, forceAnchorTag: false }]
    }, [])
    .slice(0, MAXIMUM_INSURANCE_CARDS_TO_DISPLAY)
}
